import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// project imports
import App from './App.js';
import { BASE_PATH } from '@/config.js';
import { store, persister } from './store';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from './contexts/ConfigContext';
import { version as appVersion } from '../package.json';

// style + assets
import './assets/scss/style.scss';

// ==============================|| REACT DOM RENDER  ||============================== //

const VITE_PRELOAD_RELOAD_KEY = 'vite-preload-reload-version';

if (import.meta.env.PROD) {
    window.addEventListener('vite:preloadError', (event) => {
        try {
            const attemptedVersion = sessionStorage.getItem(VITE_PRELOAD_RELOAD_KEY);

            // Let the normal error boundary handle a persistent failure.
            if (attemptedVersion === appVersion) {
                return;
            }

            sessionStorage.setItem(VITE_PRELOAD_RELOAD_KEY, appVersion);
        } catch {
            // Storage unavailable: avoid risking an infinite reload loop.
            return;
        }

        event.preventDefault();
        window.location.reload();
    });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persister}>
            <ConfigProvider>
                <BrowserRouter basename={BASE_PATH}>
                    <App />
                </BrowserRouter>
            </ConfigProvider>
        </PersistGate>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// If you want to change unregister() to register() below. Note this comes with some pitfalls.
// Then make ensure one of the following is true:
// i) We have public/service-worker.js (or)
// You configure vite-plugin-pwa
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
